import { render, staticRenderFns } from "./AgendaAulaTeorico.vue?vue&type=template&id=12c7a45a"
import script from "./AgendaAulaTeorico.vue?vue&type=script&lang=js"
export * from "./AgendaAulaTeorico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports